<template>
  <v-tab-item key="research-questions" value="research-questions">
    <v-row>
      <v-col cols="12">
        <div class="px-3 px-md-0">
          <h2
            class="title font-weight-bold pb-2 border-bottom border-thick border-primary"
          >
            Research Questions
          </h2>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pb-0">
        <div class="px-3 px-md-0">
          <ResearchDirectionsQuestionsTooltip />
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pt-0">
        <ContainerGrid>
          <LayoutItems
            ref="researchDirectionsQuestionsContainer"
            :items="questionsToDisplay"
            component-name="ResearchDirectionsQuestionsTile"
            cols="12"
            sm="12"
            md="12"
            lg="12"
            class="pt-0 px-md-0"
          />
        </ContainerGrid>
      </v-col>
    </v-row>

    <v-row v-if="isQuestionsExceededLimit && showLimitedQuestions">
      <v-col cols="12">
        <div class="text-center">
          <v-btn
            :aria-label="ariaLabel"
            outlined
            rounded
            @click="showAllQuestions"
          >
            View All
            <span class="d-sr-only"
              >questions for community {{ communityName }}</span
            >
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-tab-item>
</template>

<script>
import { mapState } from "vuex";

import ContainerGrid from "~/components/layout/ContainerGrid";
import LayoutItems from "~/components/layout/LayoutItems";

import ResearchDirectionsQuestionsTooltip from "~/components/research-directions/ResearchDirectionsQuestionsTooltip.vue";

const QUESTIONS_LIMIT = 10;

export default {
  name: "ResearchDirectionsQuestionsTab",
  components: {
    ContainerGrid,
    LayoutItems,
    ResearchDirectionsQuestionsTooltip,
  },
  props: {
    communityName: { type: String, required: true },
  },
  data() {
    return {
      showLimitedQuestions: true,
    };
  },
  computed: {
    ...mapState({
      researchDirectionsQuestions: (state) => state.selectedCommunity.questions,
    }),
    ariaLabel() {
      return `View all questions for community ${this.communityName}`;
    },
    questionsToDisplay() {
      const limitedResearchDirectionsQuestions = [
        ...this.researchDirectionsQuestions,
      ].slice(0, QUESTIONS_LIMIT);
      return this.showLimitedQuestions
        ? limitedResearchDirectionsQuestions
        : this.researchDirectionsQuestions;
    },
    isQuestionsExceededLimit() {
      return this.researchDirectionsQuestions.length > QUESTIONS_LIMIT;
    },
  },
  methods: {
    showAllQuestions() {
      this.showLimitedQuestions = false;
      this.setFocusOnFirstAdditionalQuestionTile();
    },
    setFocusOnFirstAdditionalQuestionTile() {
      this.$nextTick(() => {
        const container = this.$refs.researchDirectionsQuestionsContainer;
        const firstTile = container.$children[QUESTIONS_LIMIT];
        const firstTileButton = firstTile.$children[0].$el;

        firstTileButton.focus();
      });
    },
  },
};
</script>
